<script>

import apiHelper from "@/mixins/apiHelper.js";
import FileBrowserUploadDescription from "@/components/FileBrowserUploadDescription.vue";

export default {
  components: {
    FileBrowserUploadDescription,
  },
  mixins: [
    apiHelper,
  ],
  props: {
    fileUploadUrl: {
      type: String,
      required: true,
    },
    fileMaxSize: {
      type: Number,
      required: false,
      default: 1024 * 1024 * 10
    },
    fileAllowedExtensions: {
      type: String,
      required: false,
      default: 'txt rtf odf pdf doc docx ppt pptx xls xlsx xml zip rar jpg jpeg png gif csv wav' // This should be the same as FileFolder::getAllowedExtensions()
    },
  },
  emits: ['uploadSuccess'],
  data() {
    return {
      dialog: false,
      files: [],
    }
  },
  computed: {
    computedFileUploadUrl() {
      return this.fileUploadUrl;
    },
    /**
     * Convert allowed file extensions to comma separated string.
     * Input: 'jpg jpeg png gif pdf doc docx xls xlsx ppt pptx zip'
     * Output: '.jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip'
     *
     * @returns {string}
     */
    fileExtensionsCommaSeparated() {
      // Get allowed file extensions as array
      let allowedExtensions = this.fileAllowedExtensions.split(' ');
      // Add dot in front of each extension
      allowedExtensions = allowedExtensions.map(extension => '.' + extension);
      // Convert to comma separated string
      return allowedExtensions.join(', ');
    },
  },
  methods: {
    onUpload(event) {
      // Add files to uploaded files array
      this.addFiles(event.xhr);

      // Collect all files that are uploaded successfully
      let files_uploaded = this.files.filter(file => file.status_code === 'success');

      // Emit event with successful uploaded files
      this.$emit('uploadSuccess', files_uploaded);

      // Clear files inside the file uploader
      this.$refs.fileUpload.clear();
      this.$refs.fileUpload.uploadedFileCount = 0;
    },
    onError(event) {
      // Get status code
      const status_code = event.xhr.status;
      // Get status text
      const status_text = event.xhr.statusText;

      // Check the status code
      if (event.xhr.status !== 201) {
        this.$toast.add({ severity: 'error', summary: 'Fout', detail: '['+status_code+'] Bestand(en) zijn niet geupload. ' + status_text });
        return;
      }

      // Add files to uploaded files array
      this.addFiles(event.xhr);

      // Clear files inside the file uploader
      this.$refs.fileUpload.clear();
      this.$refs.fileUpload.uploadedFileCount = 0;
    },
    addFiles(request) {
      let jsonResponse = JSON.parse(request.responseText);
      // Loop over the files
      for (let i = 0; i < jsonResponse.length; i++) {
        // Add file to files array
        this.files.push(jsonResponse[i]);
      }
    },
    beforeUpload() {
      // Clear previously uploaded files array
      this.files = [];
    },
    /**
     * I think we need to set the CSRF-token in the request headers, but it seems to work without.
     *
     * @param request
     * @returns {*}
     */
    beforeSend(request) {
      // request.xhr.setRequestHeader('Accept', 'application/json');
      // request.xhr.setRequestHeader('Content-Type', 'application/json');
      // request.xhr.setRequestHeader('X-CSRF-Token', this.userCSRFToken);
      return request;
    },
    openDialog() {
      this.dialog = true;
      // Reset values
      this.files = [];
    },
    closeDialog() {
      this.dialog = false;
    },
  }
}
</script>

<template>

  <Toast position="top-center" />

  <Dialog v-model:visible="dialog" modal header="Bestanden uploaden" :style="{ width: '50rem' }">

    <template v-for="(file, index) of files" :key="file.id">
      <Message :severity="file.status_code" closable class="mt-2">
        {{ file.name }} - {{ file.status_message }}
      </Message>
    </template>
    <Message v-if="files.length" :severity="info" closable class="mt-2 mb-3">
      U kunt dit venster nu sluiten, of nog meer bestanden uploaden.
    </Message>

    <FileUpload
      ref="fileUpload"
      name="files[]"
      :with-credentials="true"
      :url="computedFileUploadUrl"
      :multiple="true"
      @upload="onUpload"
      @error="onError"
      :auto="true"
      :showUploadButton="false"
      :showCancelButton="false"
      chooseLabel="Bestanden kiezen"
      :maxFileSize="fileMaxSize"
      :accept="fileExtensionsCommaSeparated"
      @before-send="beforeSend"
      @before-upload="beforeUpload"
      invalidFileLimitMessage="Maximaal aantal bestanden overschreden, limiet is maximaal {0}."
      invalidFileSizeMessage="{0}: Ongeldige bestandsgrootte, de bestandsgrootte moet kleiner zijn dan {1}."
      invalidFileTypeMessage="{0}: Ongeldig bestandstype, toegestane bestandstypen: {1}."
    >
      <template #empty>
        <div class="p-4 flex file-upload-draggable-area align-items-center">
          <span>
          Sleep bestanden hier naartoe om ze te uploaden.
        </span>
        </div>
      </template>
    </FileUpload>

    <FileBrowserUploadDescription :file-allowed-extensions="fileAllowedExtensions" :file-max-size="fileMaxSize"></FileBrowserUploadDescription>

  </Dialog>

</template>

<style>
  .file-upload-draggable-area {
    min-height: 150px;
  }
</style>
